export enum UserNotificationMetaType {
  NOTIFICATION_ESTATE_STATUS_UPDATED_META = 'NotificationEstateStatusUpdatedMeta',
  NOTIFICATION_TASK_ASSIGNED_META = 'NotificationTaskAssignedMeta',
  NOTIFICATION_TASK_CHANGED_STATUS_META = 'NotificationTaskChangedStatusMeta'
}
